import { deepmerge } from '@mui/utils';

import { createTheme, type Theme, type ThemeOptions } from '@mui/material/styles';

import { color, darkCategoricalColor, lightCategoricalColor } from './colors';
import { components } from './components';
import { buildPalette } from './palette';
import { typography } from './typography';
import { shape } from './shape';

// This import ensures the MUI module augmentation is included in the bundle
import './muiThemeOverride.d';

export const varnishBaseOptions: ThemeOptions = {
    components,
    typography,
    color,
    darkCategoricalColor,
    lightCategoricalColor,
    cssVariables: {
        cssVarPrefix: 'ai2',
        colorSchemeSelector: 'data-color-scheme',
    },
    colorSchemes: {
        light: { palette: buildPalette('light') },
        dark: { palette: buildPalette('dark') },
    },
    spacing: (factor: number) => `${0.5 * factor}rem`,
    shape,
};

export const varnishTheme: Theme = createTheme(varnishBaseOptions);

export const getTheme = (overrides: ThemeOptions = {}): Theme => {
    return createTheme(deepmerge(varnishBaseOptions, overrides));
};

export default { getTheme };
